import type { ComponentPropsWithRef } from "react";
import { Fragment, forwardRef } from "react";
import { Combobox, Transition } from "@headlessui/react";
import classNames from "classnames";

export interface OptionsProps {
  children: ComponentPropsWithRef<typeof Combobox.Options>["children"];
  className?: string;
  dataTestId?: string;
  onClose?: () => void;
}

export const Options = forwardRef<HTMLUListElement, OptionsProps>(
  ({ onClose, children, className, dataTestId, ...rest }, ref) => (
    <Transition
      as={Fragment}
      enter="transition-opacity ease-in duration-75"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition ease-out duration-75"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
      afterLeave={onClose}
    >
      <Combobox.Options
        ref={ref}
        className={classNames(
          "border-primary bg-primary absolute mt-1 w-full overflow-hidden rounded-lg border shadow-xl focus:outline-none",
          className,
        )}
        data-testid={dataTestId}
        {...rest}
      >
        {children}
      </Combobox.Options>
    </Transition>
  ),
);

Options.displayName = "Options";
